function HistoryIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="26"
      height="24"
      fill="none"
      viewBox="0 0 26 24"
    >
      <path fill="currentColor" d="M13 8v5h5.417v-2h-3.25V8H13z"></path>
      <path
        fill="currentColor"
        d="M23.067 8.497a8.954 8.954 0 00-2.089-2.862c-1.348-1.245-3.062-2.097-4.93-2.452a10.652 10.652 0 00-3.927 0c-1.87.352-3.585 1.206-4.932 2.453a9.045 9.045 0 00-2.088 2.86A8.371 8.371 0 004.334 12v.025H2.168L5.417 16l3.25-3.975H6.501V12a6.585 6.585 0 011.294-3.913 7.389 7.389 0 012.048-1.892 7.972 7.972 0 012.712-1.054c1.97-.374 4.02-.01 5.7 1.01 1.68 1.021 2.852 2.616 3.258 4.435a6.583 6.583 0 010 2.824 6.661 6.661 0 01-1.142 2.503 7.1 7.1 0 01-.925 1.036 7.71 7.71 0 01-2.41 1.5 8.02 8.02 0 01-1.423.409 8.34 8.34 0 01-3.058 0 7.884 7.884 0 01-2.71-1.053 7.559 7.559 0 01-1.123-.855L7.19 18.364c.905.836 1.98 1.5 3.162 1.951a10.514 10.514 0 007.526-.023c1.742-.68 3.232-1.812 4.29-3.26A8.489 8.489 0 0023.834 12a8.34 8.34 0 00-.767-3.503z"
      ></path>
    </svg>
  );
}

export default HistoryIcon;
